module.exports = __webpack_public_path__ + "img/tintuc1.a6b26188.png";